import React from 'react';
import { ParallaxSection } from '../components/ParallaxSection';
import { SectionHeading } from '../components/SectionHeading';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="bg-white min-h-screen" data-id="element-224" data-mp="srkgdudg3z12">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80" height="h-[50vh]" data-id="element-225" data-mp="xpcjlkjjj7kk">
        <h1 className="text-5xl md:text-7xl font-bold font-serif text-white text-center" data-id="element-226" data-mp="10o4ox34g0fd">
          Contact Us
        </h1>
      </ParallaxSection>

      <section className="py-20 px-4 md:px-8" data-id="element-227" data-mp="a01fpu6w8x27">
        <div className="max-w-7xl mx-auto" data-id="element-228" data-mp="9z00ddiuhoeo">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-229" data-mp="eyuvxudkf262">
            {/* Form */}
            <div data-id="element-230" data-mp="ewi6kw5h9piz">
              <SectionHeading title="Get in Touch" subtitle="Ready to discuss your next project? Send us a message." centered={false} data-id="element-231" data-mp="1lf6sxs4nie02" />

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-232" data-mp="r0ey1g3nvu13">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-233" data-mp="mz3e9r7gy30t">
                  <div data-id="element-234" data-mp="mzuw7z85828m">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-235" data-mp="i006w040nkpo">
                      Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="John Doe" data-id="element-236" data-mp="czubq9yjfg2u" />
                  </div>
                  <div data-id="element-237" data-mp="3vfekskxvcwhc">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-238" data-mp="3vciot25l0hvj">
                      Email
                    </label>
                    <input type="email" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="john@company.com" data-id="element-239" data-mp="3lgyx6ry1w5cl" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-240" data-mp="3bqqlfj7364ir">
                  <div data-id="element-241" data-mp="2xuwo7xfod3lh">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-242" data-mp="2xvoin4xjcva6">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-243" data-mp="3pk83ezk4j96o" />
                  </div>
                  <div data-id="element-244" data-mp="3ks89bnqqjai0">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-245" data-mp="3krou4esgz07o">
                      Company
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="Company Name" data-id="element-246" data-mp="h4y6e5v3cu5r" />
                  </div>
                </div>

                <div data-id="element-247" data-mp="2bmzj9xxbov6h">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-248" data-mp="26ltto8yylo16">
                    Opportunity Type
                  </label>
                  <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" data-id="element-249" data-mp="1ix0sny3hcpzp">
                    <option data-id="element-250" data-mp="1suoxjgusvdvl">Land Development</option>
                    <option data-id="element-251" data-mp="1ssc9qn2d29am">Commercial Development</option>
                    <option data-id="element-252" data-mp="1nuas86kl2i19">Residential Development</option>
                    <option data-id="element-253" data-mp="349bxr6hoe1yu">Redevelopment</option>
                    <option data-id="element-254" data-mp="3480tz6o8cu7q">Tenant Improvement</option>
                    <option data-id="element-255" data-mp="2zar63vghoqm0">Other</option>
                  </select>
                </div>

                <div data-id="element-256" data-mp="18tdmznkvtwp4">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-257" data-mp="18u5hev2qtodt">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="Tell us about your project..." data-id="element-258" data-mp="1dsqi0vlwqa2s" />
                </div>

                <button className="bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-bold text-lg w-full md:w-auto transition-colors" data-id="element-259" data-mp="1wrchy75otv54">
                  Send Message
                </button>
              </form>
            </div>

            {/* Info */}
            <div className="bg-[#0A0A0A] text-white p-10 md:p-12 h-fit" data-id="element-260" data-mp="25j4my2by0c2b">
              <h3 className="text-2xl font-bold font-serif mb-8 text-[#C5A55A]" data-id="element-261" data-mp="2ajsgaunn94zp">
                Contact Information
              </h3>

              <div className="space-y-8" data-id="element-262" data-mp="2ffpvgxn685aw">
                <div className="flex items-start gap-4" data-id="element-263" data-mp="2pmada3ezobcc">
                  <MapPin className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-264" data-mp="2pjo6w73u41vp" />
                  <div data-id="element-265" data-mp="2kl34q250v84m">
                    <p className="font-bold mb-1" data-id="element-266" data-mp="2koqvwumzvig6">Headquarters</p>
                    <p className="text-gray-400" data-id="element-267" data-mp="2focqzlgowomd">
                      1234 Construction Blvd
                      <br data-id="element-268" data-mp="2bnaz5pp3reuf" />
                      Fort Myers, FL 33901
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-269" data-mp="38e369xu25wk2">
                  <Phone className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-270" data-mp="33egrvl2hua9o" />
                  <div data-id="element-271" data-mp="2ylxi6z6xfza5">
                    <p className="font-bold mb-1" data-id="element-272" data-mp="2yl4fc9b39txa">Phone</p>
                    <p className="text-gray-400" data-id="element-273" data-mp="2ul3plsijhwax">239-810-9482</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-274" data-mp="3r39t9x1vxabo">
                  <Mail className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-275" data-mp="3r4uolow0wxal" />
                  <div data-id="element-276" data-mp="3magnd5uojvy0">
                    <p className="font-bold mb-1" data-id="element-277" data-mp="3m9x51o14b5jg">Email</p>
                    <p className="text-gray-400" data-id="element-278" data-mp="1kfivx1knbekc">info@sinclairdevelops.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-279" data-mp="1pcst53ea0uiq">
                  <Clock className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-280" data-mp="1ap7oh51r6n8p" />
                  <div data-id="element-281" data-mp="1fnrdxffk2h5t">
                    <p className="font-bold mb-1" data-id="element-282" data-mp="1fmziq5pvelg2">Hours</p>
                    <p className="text-gray-400" data-id="element-283" data-mp="1flem8ajzwsfk">
                      Mon - Fri: 8:00 AM - 6:00 PM
                      <br data-id="element-284" data-mp="11qcj1v6j9h6g" />
                      Sat - Sun: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="mt-10 w-full h-64 bg-gray-800 rounded-sm flex items-center justify-center relative overflow-hidden group" data-id="element-285" data-mp="rrwpzmny3xub">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80')] bg-cover bg-center opacity-50 group-hover:opacity-60 transition-opacity" data-id="element-286" data-mp="2m3bgi5os61b4" />
                <MapPin className="w-12 h-12 text-[#C5A55A] relative z-10 drop-shadow-lg" data-id="element-287" data-mp="fet3x9y94kfo" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}